import { Injectable } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ModalConfig } from '../models/modalConfig';
import { UploadReqAddEditEndClientModalComponent } from 'src/app/pages/mission-control-page/upload-req-page/upload-req-add-edit-end-client-modal/upload-req-add-edit-end-client-modal.component';

@Injectable({
  providedIn: 'root'
})
export class UploadReqAddEditEndClientModalService {

  addEditEndClientModal!: BsModalRef;

  constructor(private bsModalService: BsModalService) { }

  show(type: any, addEditClientName: any, isEndClientNameValid: any, endClientDetails: any, saveCallback: (type: any, addEditClientName: any, successCallback: () => void) => void): void {
    const config = new ModalConfig();
    config.class = 'four-dot-five-modal-extra-small';
    config.initialState = { type, addEditClientName, isEndClientNameValid, endClientDetails, saveCallback };
    this.addEditEndClientModal = this.bsModalService.show(UploadReqAddEditEndClientModalComponent, config);
  }
}
